import { EolQuoteParameterInit } from '../../../models/configurators-2d/applications/carpentry/Elcia/eol-quote-parameter-init';
import { IShoppingCartService } from '../shopping-cart/i-shopping-cart-service';
import { QuotationEdit } from '../../../models/configurators-2d/applications/carpentry/Elcia/quotation-edit';
import { inject, Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { BaseAppService } from '../base-app-service';
import { CONFIG_CONTEXT } from '../../../enum/config-context.enum';
import { Configuration } from '../../../models/configurators-2d/applications/carpentry/configuration';
import { QuotationInit } from 'src/app/models/configurators-2d/applications/carpentry/Elcia/quotation-init';
import { Quotation } from 'src/app/models/configurators-2d/applications/carpentry/Elcia/quotation';
import { QuotationDetail } from 'src/app/models/configurators-2d/applications/carpentry/Elcia/quotation-details/quotation-detail';
import { EolQuoteParameter } from 'src/app/models/configurators-2d/applications/carpentry/Elcia/eol-quote-parameter';
import { ShoppingCartProduct } from 'src/app/models/shopping-cart/shopping-cart-product';
import { QuotationRecord } from 'src/app/models/configurators-2d/applications/carpentry/quotation-record';
import { ShoppingCartProductInformation } from 'src/app/models/shopping-cart/shopping-cart-product-information';
import { InformationTypeEnum } from 'src/app/enum/shopping-cart/information-type.enum';
import { ShoppingCartProductList } from 'src/app/models/shopping-cart/shopping-cart-product-list';
import { BaseQuotation } from 'src/app/models/configurators-2d/applications/carpentry/Elcia/base-quotation';
import { Parameters } from 'src/app/models/configurators-2d/applications/carpentry/Elcia/parameters';
import { QuoteOrder } from 'src/app/models/configurators-2d/applications/carpentry/Elcia/order/quote-order';
import { PostOrderParameters } from 'src/app/models/configurators-2d/applications/carpentry/Elcia/order/post-order-parameters';
import { QuotationRecordInformation } from 'src/app/models/configurators-2d/applications/carpentry/Elcia/order/quotation-record-information';
import { OrderInformation } from 'src/app/models/configurators-2d/applications/carpentry/Elcia/order/order-information';
import { CheckOrderRequest } from 'src/app/models/configurators-2d/applications/carpentry/Elcia/order/check-order-request';
import { CheckOrderResult } from 'src/app/models/configurators-2d/applications/carpentry/Elcia/order/check-order-result';
import { Accessory } from 'src/app/models/configurators-2d/applications/carpentry/accessory/accessory';
import { TranslateService } from '@ngx-translate/core';
import { ShoppingCartDiscount } from 'src/app/models/shopping-cart/shopping-cart-discount';
import { ShoppingCartAssistanceType } from 'src/app/models/shopping-cart/shopping-cart-assistance-type';
import { ConfigurationAssistance } from 'src/app/models/configurators-2d/applications/carpentry/assistance/configuration-assistance';
import { ShoppingCartAssistance } from 'src/app/models/shopping-cart/shopping-cart-assistance';
import { VatUpdate } from 'src/app/models/configurators-2d/applications/carpentry/Elcia/vat-update';
import { OrderResponse } from 'src/app/models/configurators-2d/applications/carpentry/Elcia/order/order-response';
import { Dimension } from 'src/app/models/configurators-2d/applications/carpentry/Elcia/quotation-details/dimension';
import { environment } from 'src/environments/environment';
import { DatasService } from '../../datas.service';
import { CustomerService } from '../../customer.service';
import {
  BaseCarpentryConfigurationDto,
  CarpentryConfiguration,
  CarpentryCreateUpdateTunnel,
  CarpentryInstallationDto,
  CarpentryTunnelPricingDto,
} from 'src/app/models/configurators-2d/tunnel/carpentry/carpentry-tunnel-dtos';
import { TunnelDataStore } from 'src/app/stores/tunnel/tunnel-data.store';
import { FundingState, InstallationState, Price, PricingState } from 'src/app/stores/tunnel/model/tunnel-data-state';
import {
  ComputeInstallationOptions,
  FundingLegalInformation,
  GetFundingDataInput,
  GetFundingLegalInformationInput,
  GetInstallationDataInput,
  GetPricingInput,
  HbmPdfViewModel,
  TunnelUpdateInstallation,
  UpdateInstallationInput,
} from 'src/app/models/configurators-2d/tunnel/common-tunnel-dtos';
import { FidelityService } from '../../fidelity/fidelity.service';
import { GetCustomerFidelityInfoNouveauPointInput } from '../../fidelity/fidelity';
import { logError } from '../../helpers/sentry.helper';
import { FundingRehydrationService } from '../funding-rehydration.service';
import { CarpentryConfigurationData } from 'src/app/stores/tunnel/model/configuration-data/carpentry-configuration-data';
import { FeatureSettingsService } from '../../feature-settings/feature-settings.service';
import { MODAL } from '../../modal.service';
import { OrderBeforeSendCheckResult } from 'src/app/models/configurators-2d/tunnel/order-before-send-check-result';

@Injectable({
  providedIn: 'root',
})
export class CarpentryService extends BaseAppService<Configuration> implements IShoppingCartService {
  private readonly fundingRehydration = inject(FundingRehydrationService);
  /** Id du quotationRecord à éditer (communication entre tunnel steps) */
  pendingEditQuotationRecordId: number | undefined = undefined;

  private readonly tunnelDataStore = inject(TunnelDataStore);
  private readonly fidelityService = inject(FidelityService);
  private readonly featureSettingsService = inject(FeatureSettingsService);

  private currentInstallation: InstallationState;
  private currentPricing: PricingState;
  private currentFunding: FundingState;
  private readonly subscriptions: Subscription[] = [];

  //paramètres Elcia par défaut
  parameters: Parameters = {
    organisation: undefined,
    userName: undefined,
  };

  baseQuotation: BaseQuotation;
  quotationInit: QuotationInit;
  lang: string;

  eolQuoteParameters: EolQuoteParameter = {
    authorizeComposite: true,
    authorizeForcePurchase: true,
    authorizeForceSale: true,
    authorizeNonStandard: false,
    authorizeNullQuantity: true,
    displayAccordionMode: 'Default',
    displayCustomerObservation: true,
    displayLocation: true,
    displayPriceMode: 'SalePrice',
    displayResellerMargin: false,
    invertedDimensions: false,
    maxForceable: true,
    minForceable: true,
    purchaseNoImpactSale: false,
    technicalValidationMode: 'TechnicalValidationSwichable',
    updatePricerVersionMode: 'possible',
    vatRates: [20, 10, 5.5],
  };

  eolQuoteParameterInit: EolQuoteParameterInit = {
    saleCalculationMode: 'coefficient',
    targetValueCalculation: false,
    ...this.eolQuoteParameters,
  };

  constructor(
    datas: DatasService,
    translateService: TranslateService,
    private customerService: CustomerService
  ) {
    super(CONFIG_CONTEXT.CARPENTRY, Configuration);
    this.lang = translateService.getBrowserLang().substring(0, 2);
    this.baseQuotation = {
      culture: `${this.lang}-${this.lang.toUpperCase()}`,
      ...this.parameters,
    };

    //if user is admin, display all prices
    if (datas.applications.get(environment.configurators2d.applications.carpentry.distribID).adminEnabled) {
      this.eolQuoteParameterInit.displayPriceMode = 'All';
    }

    this.quotationInit = {
      eolQuoteParameters: this.eolQuoteParameterInit,
      ...this.baseQuotation,
    };

    this.subscribeToStoreObservables();
  }

  isInstallationDisabled(): boolean {
    return environment.installationSpecifics.carpentry.disableInstallation;
  }

  /** i-shopping-cart-service */

  getBaseImgUrl(): string {
    return this.apiUrl;
  }
  /** Requêtes auprès d'Elcia */

  getProductVats(): number[] {
    return this.eolQuoteParameters.vatRates;
  }

  /**
   * Mise à jour de la quantité auprès d'Elcia
   * @param product
   * @returns number
   */
  updateQuantity(product: ShoppingCartProduct): Promise<number> {
    const body: Quotation = {
      culture: undefined,
      quantity: product.quantity,
      quotationRecordId: product.externalId,
      ...this.parameters,
    };

    return this.post<number>(this.apiUrl + 'Elcia/QuotationRecord/Quantity', body);
  }

  /**
   * Duplication d'un produit côté Elcia
   * @param product
   * @returns number
   */
  duplicate(product: ShoppingCartProduct): Promise<number> {
    // Si on duplique un produit, on doit lui donner un nouvel index
    product.index = this.getNextSortIndex();

    const body: Quotation = {
      culture: undefined,
      quantity: product.quantity,
      quotationRecordId: product.externalId,
      ...this.parameters,
    };

    return this.post<number>(this.apiUrl + 'Elcia/QuotationRecord/Duplicate', body);
  }

  /**
   * Mise à jour de la tva auprès d'Elcia
   * @param product
   * @returns
   */
  updateTva(product: ShoppingCartProduct): Promise<number> {
    const body: VatUpdate = {
      quotationRecordId: product.externalId,
      vat: product.tva,
      ...this.parameters,
    };

    return this.post<number>(this.apiUrl + 'Elcia/QuotationRecord/Vat', body);
  }

  /**
   * Fonction pour récupérer les détails d'un produit auprès d'Elcia
   * @param product
   * @returns
   */
  async getProductDetails(product: ShoppingCartProduct): Promise<ShoppingCartProduct> {
    const details: QuotationDetail = await this.getQuotationRecordDetails(product.externalId);
    const newProduct: ShoppingCartProduct = this.convertDetailToShoppingCartProduct(details);
    newProduct.creationTime = product.creationTime;
    newProduct.creatorId = product.creatorId;
    newProduct.id = product.id;
    return newProduct;
  }

  /** Requêtes configuration*/

  /**
   * Fonction de récupérations des services menuiserie
   * @returns
   */
  getAssistances(): Promise<ShoppingCartAssistanceType[]> {
    return this.get<ShoppingCartAssistanceType[]>(this.apiUrl + 'Configuration/Assistances');
  }

  /**
   * Fonction de récupération des id (guid) de quotationRecord
   * @param productList
   */
  async prepareOrderNumberEdition(productList: ShoppingCartProductList): Promise<void> {
    let project = await this.getProjectById(this.configuration.id, true);
    productList.shoppingCartProductCategories.forEach(c =>
      c.shoppingCartProducts.forEach(p => {
        let id = project.quotationRecords.find(r => r.externalId == p.externalId).id;
        p.id = id;
        this.configuration.quotationRecords.find(q => q.externalId == p.externalId).id = id;
      })
    );
  }

  /** Elcia request */

  /**
   * Fonction de récupération d'un ert de chiffrage initial
   * @returns
   */
  async getInitialQuoteErt(): Promise<string> {
    const res = await this.post(this.apiUrl + 'Elcia/InitializeQuote', this.quotationInit);
    return res.payload;
  }

  /**
   * Fonction de récupération d'un ert de modification de chiffrage
   * @returns
   */
  async getEditQuoteErt(quotationRecordId: number): Promise<string> {
    const body: QuotationEdit = {
      quotationRecordId: quotationRecordId,
      quantity: undefined,
      eolQuoteParameters: this.eolQuoteParameters,
      ...this.baseQuotation,
    };

    const res = await this.post(this.apiUrl + 'Elcia/EditQuote', body);
    return res.payload;
  }

  /**
   * Fonction de récupération des détails d'un produit
   * @param quotationRecordId
   * @returns
   */
  getQuotationRecordDetails(quotationRecordId: number): Promise<QuotationDetail> {
    const body: Quotation = {
      quantity: undefined,
      quotationRecordId: quotationRecordId,
      ...this.baseQuotation,
    };

    return this.post<QuotationDetail>(this.apiUrl + 'Elcia/QuotationRecord/Details', body);
  }

  /**
   * Fonction de création d'une commande fournisseur
   * @param products
   * @returns
   */
  override createSupplierOrder(products: ShoppingCartProduct[]): Promise<OrderResponse> {
    const quotationRecordInformations: QuotationRecordInformation[] = [];

    products.forEach(p => {
      quotationRecordInformations.push({
        quotationRecordClientId: p.ean,
        quotationRecordId: p.externalId,
      });
    });

    const orderInformation: OrderInformation = {
      warehouseCode: this.current.vendor?.store?.SAPStoreId,
      salesRep: undefined,
      userLastName: undefined,
      documentDate: undefined,
      documentNumber: undefined,
      documentTitle: undefined,
      comment: undefined,
      userEmail: undefined,
      userFirstName: undefined,
      userPostalCode: undefined,
      expectedDeliveryDate: undefined,
      expectedDeliveryWeek: undefined,
      companyCode: 'CASTORAMA',
      companyName: 'CASTORAMA FRANCE',
      branchCode: this.current.vendor?.store?.name,
      siteCode: undefined,
      orderNumber: products[0].orderNumber,
      deliveryInformation: undefined,
      additionalInformations: undefined,
    };

    const param: PostOrderParameters = {
      quotationRecordInformations: quotationRecordInformations,
      orderInformation: orderInformation,
    };

    const body: QuoteOrder = {
      postOrderParameters: param,
      ...this.baseQuotation,
    };

    return this.post<OrderResponse>(this.apiUrl + 'Elcia/Order', body);
  }

  /**
   * Fonction de vérification de la commande
   * @param quotationRecordIds
   * @returns
   */
  checkOrder(quotationRecordIds: number[]): Promise<CheckOrderResult> {
    const body: CheckOrderRequest = {
      quotationRecordIds: quotationRecordIds,
      ...this.baseQuotation,
    };

    return this.post<CheckOrderResult>(this.apiUrl + 'Elcia/Order/Check', body);
  }

  /**
   * Construit un résumé exploitable par l'UI à partir du check Elcia.
   * On lit d'abord la configuration présente dans le tunnel pour rester aligné
   * avec l'état réellement affiché au moment du clic sur "Envoyer".
   */
  async checkCurrentConfigurationOrder(): Promise<CarpentryOrderCheckSummary> {
    const tunnelConfiguration = this.tunnelDataStore
      .getCurrentStateValue()
      .configurationData.get(CONFIG_CONTEXT.CARPENTRY) as Configuration | undefined;

    const quotationRecords = tunnelConfiguration?.quotationRecords ?? this.configuration?.quotationRecords ?? [];
    if (!quotationRecords.length) {
      return {
        isValid: true,
        result: { quotationRecordCheckResults: [] },
        invalidProducts: [],
      };
    }

    const result = await this.checkOrder(quotationRecords.map(record => record.externalId));
    const invalidIds = new Set(
      (result?.quotationRecordCheckResults ?? [])
        .filter(check => check.errorCode !== '' && check.errorCode != undefined)
        .map(check => check.quotationRecordId)
    );

    return {
      isValid: invalidIds.size === 0,
      result,
      invalidProducts: quotationRecords
        .filter(record => invalidIds.has(record.externalId))
        .map(record => this.convertToShoppingCartProduct(record)),
    };
  }

  /**
   * Implémentation tunnel du check de commande menuiserie.
   * On retourne un contrat générique pour que l'action bar puisse rester
   * agnostique du métier et se contenter d'afficher la bonne modale.
   */
  override async checkOrderBeforeSend(): Promise<OrderBeforeSendCheckResult> {
    const summary = await this.checkCurrentConfigurationOrder();

    if (summary.isValid) {
      return {
        isValid: true,
      };
    }

    return {
      isValid: false,
      modalId: MODAL.SHOPPING_CART_CHECK_ORDER,
      modalData: {
        products: summary.invalidProducts,
        checkOrder: summary.result,
      },
    };
  }

  /** Requêtes configurateur */
  /**
   * Fonction de mise à jour d'un quotationRecord
   * @param record
   * @returns
   */
  override updateProductOrder(record: ShoppingCartProduct): Promise<void> {
    const body: QuotationRecord = this.convertToQuotationRecord(record);
    return this.put(this.apiUrl + 'Configuration/QuotationRecord', body);
  }

  /**
   *
   */
  getAccessoriesAvailable(productCode: string): Promise<boolean> {
    const params = new URLSearchParams();
    params.set('productCode', productCode);
    return this.get<boolean>(this.apiUrl + 'Configuration/AccessoriesAvailable?' + params.toString());
  }

  /**
   * Fonction de récupération des accessoires possibles pour un produit
   * @param productCode
   * @returns
   */
  getAccessories(productCode: string): Promise<Accessory[]> {
    const params = new URLSearchParams();
    params.set('productCode', productCode);
    return this.get<Accessory[]>(this.apiUrl + 'Configuration/Accessories?' + params.toString());
  }

  /**
   * Fonction de récupération d'une remise
   * @param productCode
   * @param discountValue
   * @returns
   */
  getProductDiscount(productCode: string, discountValue: number): Promise<ShoppingCartDiscount> {
    const params = new URLSearchParams();
    params.set('productCode', productCode);
    params.set('discountValue', discountValue.toString());
    return this.get<ShoppingCartDiscount>(this.apiUrl + 'Configuration/Discount?' + params.toString());
  }

  /**
   * Fonction de récupération des remises valides
   * @returns
   */
  getProductDiscounts(): Promise<ShoppingCartDiscount[]> {
    return this.get<ShoppingCartDiscount[]>(this.apiUrl + 'Configuration/Discounts');
  }

  /** Requêtes d'administration */

  /**
   * Fonction de mise à jour des prix des accessoires
   * @param file
   * @returns
   */
  setAdminAccessoriesPrices(file: File): Promise<any> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.post(`${this.apiUrl}Data/UpdateAccessories`, formData);
  }

  /** Requêtes de transformation */

  /**
   * Conversion de QuotationDetail d'Elcia -> ShoppingCartProduct
   * @param details
   * @returns
   */
  convertDetailToShoppingCartProduct(details: QuotationDetail): ShoppingCartProduct {
    let informations: ShoppingCartProductInformation[] = [];
    //Ajout du repère comme première information
    if (details.eolDetails.quotationRecord.location) {
      informations.push({
        label: `Repère ${details.eolDetails.quotationRecord.location}`,
        informationType: InformationTypeEnum.Option,
        creationTime: undefined,
        lastModificationTime: undefined,
        id: undefined,
      });
    }

    // Ajout des dimensions comme deuxième information.
    if (
      details.eolDetails.quotationRecord.product.dimension1 ||
      details.eolDetails.quotationRecord.product.dimension2
    ) {
      const dimension1 = details.eolDetails.quotationRecord.product.dimension1;
      const dimension2 = details.eolDetails.quotationRecord.product.dimension2;
      informations.push({
        label: this.concatDimensionLabel(dimension1, dimension2),
        informationType: InformationTypeEnum.Option,
        creationTime: undefined,
        lastModificationTime: undefined,
        id: undefined,
      });
    }

    if (details.eolDetails.quotationRecord.product.options) {
      details.eolDetails.quotationRecord.product.options.forEach(o =>
        informations.push({
          label: o.name,
          informationType: InformationTypeEnum.Option,
          creationTime: undefined,
          lastModificationTime: undefined,
          id: undefined,
        })
      );
    }

    if (details.eolDetails.quotationRecord.observations.customer != undefined) {
      if (!informations) {
        informations = [];
      }
      informations.push({
        label: details.eolDetails.quotationRecord.observations.customer,
        informationType: InformationTypeEnum.CustomerObservation,
        creationTime: undefined,
        lastModificationTime: undefined,
        id: undefined,
      });
    }

    //cas chassis composé
    if (details.eolDetails.quotationRecord.product.composite?.areas) {
      details.eolDetails.quotationRecord.product.composite.areas.forEach(a => {
        informations.push({
          label: `Zone ${a.number}: ${a.product?.name}`,
          informationType: InformationTypeEnum.Option,
          creationTime: undefined,
          lastModificationTime: undefined,
          id: undefined,
        });

        if (a.product?.dimension1?.value) {
          informations.push({
            label: `${a.product?.dimension1?.label}: ${a.product?.dimension1?.value} ${a.product?.dimension1?.unit}`,
            informationType: InformationTypeEnum.Option,
            creationTime: undefined,
            lastModificationTime: undefined,
            id: undefined,
          });
        }

        if (a.product?.dimension2?.value) {
          informations.push({
            label: `${a.product?.dimension2?.label}: ${a.product?.dimension2?.value} ${a.product?.dimension2?.unit}`,
            informationType: InformationTypeEnum.Option,
            creationTime: undefined,
            lastModificationTime: undefined,
            id: undefined,
          });
        }

        if (a.product?.options?.length) {
          a.product.options.forEach(opt => {
            informations.push({
              label: opt.name,
              informationType: InformationTypeEnum.Option,
              creationTime: undefined,
              lastModificationTime: undefined,
              id: undefined,
            });
          });
        }
      });
    }

    return new ShoppingCartProduct(
      //Id
      undefined,
      //externalId
      details.eolDetails.quotationRecord.quotationRecordId,
      //name
      details.eolDetails.quotationRecord.product.name,
      //thumbnail
      details.eolDetails.quotationRecord.printImage?.value,
      //productCode
      details.agoraDetails.customizedProductCode,
      //ean
      undefined,
      //quantity
      details.eolDetails.quotationRecord.product.quantity,
      //unitPurchasePriceHt
      details.eolDetails.quotationRecord.pricing.totalPurchasePrice,
      //unitPriceHt
      details.eolDetails.quotationRecord.pricing.totalSalePrice, //prix de base unitaire sans ecotax
      //discount
      details.eolDetails.quotationRecord.pricing.saleCustomerDiscountPercentage,
      //tva
      details.eolDetails.quotationRecord.pricing.vatRate ?? 0,
      //ecoTax
      details.eolDetails.quotationRecord.pricing.saleUnitPrice -
        details.eolDetails.quotationRecord.pricing.totalSalePrice,
      //informations
      informations,
      //accessories
      undefined,
      //orderNumber
      undefined,
      //supplierName
      details.eolDetails.quotationRecord.supplier.name,
      //supplierSent
      false,
      //supplierSentLastDate
      undefined,
      //automaticSupplierSent
      undefined,
      //composite
      details.eolDetails.quotationRecord.product.composite
    );
  }

  private concatDimensionLabel(dimension1?: Dimension, dimension2?: Dimension): string {
    if (dimension1 && dimension2) {
      return `${dimension1.shortLabel} ${dimension1.value} ${dimension1.unit} X ${dimension2.shortLabel} ${dimension2.value} ${dimension2.unit}`;
    }

    if (dimension1 || dimension2) {
      const dimension = dimension1 || dimension2;
      return `${dimension.shortLabel} ${dimension.value} ${dimension.unit}`;
    }

    return '';
  }

  /**
   * Conversion ShoppingCartProduct -> QuotationRecord
   * @param product
   * @returns
   */
  convertToQuotationRecord(product: ShoppingCartProduct): QuotationRecord {
    const productReferenceElcia = (product as QuotationRecord).referenceElcia;

    return new QuotationRecord(
      product.id,
      product.externalId,
      product.name,
      product.thumbnail,
      product.productCode,
      product.ean,
      product.quantity,
      product.unitPurchasePriceHt,
      product.unitPriceHt,
      product.discount,
      product.tva,
      product.unitEcoTax,
      product.informations,
      product.accessories,
      product.orderNumber,
      product.supplierName,
      product.supplierSent,
      undefined,
      product.supplierSentLastDate,
      product.automaticSupplierSent,
      product.composite,
      productReferenceElcia,
      product.index
    );
  }

  /**
   * Conversion QuotationRecord -> ShoppingCartProduct
   * @param record
   * @returns
   */
  convertToShoppingCartProduct(record: QuotationRecord): ShoppingCartProduct {
    return new QuotationRecord(
      record.id,
      record.externalId,
      record.name,
      record.thumbnail,
      record.productCode,
      record.ean,
      record.quantity,
      record.unitPurchasePriceHt,
      record.unitPriceHt,
      record.discount,
      record.tva,
      record.unitEcoTax,
      record.informations,
      record.accessories,
      record.orderNumber,
      record.supplierName,
      record.supplierSent,
      record.previousQuotationRecordId,
      record.supplierSentLastDate,
      record.automaticSupplierSent,
      record.composite,
      record.referenceElcia,
      record.index
    );
  }

  /**
   * Conversion ConfigurationService -> ShoppingCartService
   * @param service
   * @returns
   */
  convertToShoppingCartService(assistance: ConfigurationAssistance): ShoppingCartAssistance {
    return {
      assistanceType: assistance.assistanceType,
      priceTtc: assistance.priceTtc,
      tva: assistance.tva,
    };
  }

  /**
   * Conversion ShoppingCartProductList -> Configuration.QuotationRecords
   * @param productList
   */
  override addProductListToConfiguration(productList: ShoppingCartProductList): void {
    const records: QuotationRecord[] = [];
    productList.shoppingCartProductCategories.forEach(c =>
      c.shoppingCartProducts.forEach(p => records.push(this.convertToQuotationRecord(p)))
    );
    this.configuration.quotationRecords = records;
    this.configuration.assistances = productList.shoppingCartAssistances;
  }

  public getNextSortIndex(): number {
    return (this.configuration.quotationRecords ?? []).reduce((max, r) => Math.max(max, r.index ?? -1), -1) + 1;
  }

  /**
   * Reconstitue les quotationRecords en instances de classe QuotationRecord
   * après un chargement brut depuis le backend (JSON → class avec getters calculés).
   */
  recreateQuotationRecords(): void {
    if (!this.configuration.quotationRecords?.length) return;
    this.configuration.quotationRecords = this.configuration.quotationRecords.map(r =>
      this.convertToQuotationRecord(r)
    );
  }

  /**
   * Charge les données d'un tunnel existant (installation, tarif, fidélité).
   * Utilisé au chargement d'un projet existant qui a déjà un tunnelId.
   */
  public async loadExistingTunnelData(): Promise<void> {
    if (!this.configuration.quotationRecords?.length) return;
    // Chargement : on laisse l'API répondre avec l'âge d'habitation persisté du projet.
    await this.computeInstallation({ usePersistedHouseAge: true });
    await this.loadCarpentryPricing();
    // Filet : `Tunnel/pricing` ne ramène pas toujours les offres persistées.
    await this.fundingRehydration.rehydrateIfNeeded(this.configuration.tunnelId, this);
    await this.computeFidelity();
  }

  /**
   * Sauvegarde la configuration sur le backend (création ou mise à jour),
   * puis crée ou récupère le tunnel associé via GET /Tunnel/{configId}.
   * Le backend auto-crée le tunnel si aucun n'existe pour cette configuration.
   * Appelé uniquement depuis beforeNextAction, après sélection du client.
   */
  async loadOrCreateConfiguration(): Promise<void> {
    this.configuration.customerId = this.customerService.userDatas?.id;

    // Crée ou met à jour la configuration (POST ou PUT /Configuration)
    const saveSucceeded = await this.saveProject();
    if (!saveSucceeded || !this.configuration.id) {
      throw new Error("Impossible de sauvegarder la configuration menuiserie avant de créer ou charger le tunnel.");
    }

    // Crée ou récupère le tunnel associé, stocke le tunnelId pour les étapes suivantes
    const tunnel = await this.getCarpentryTunnelByConfigId(this.configuration.id);
    if (!tunnel?.id) {
      throw new Error("Impossible de récupérer le tunnel menuiserie associé à la configuration.");
    }
    this.configuration.tunnelId = tunnel.id;

    // Charger les données du tunnel si des produits existent
    if (this.configuration.quotationRecords?.length > 0) {
      // Chargement : on laisse l'API répondre avec l'âge d'habitation persisté du projet.
      await this.computeInstallation({ usePersistedHouseAge: true });
      await this.loadCarpentryPricing();
      await this.computeFidelity();
    }
  }

  /** Abonnements aux observables du store pour garder les états locaux synchronisés */
  private subscribeToStoreObservables(): void {
    this.subscriptions.push(
      this.tunnelDataStore.getCurrentInstallation().subscribe(installation => {
        if (installation) {
          this.currentInstallation = installation;
        }
      }),
      this.tunnelDataStore.getCurrentFunding().subscribe(funding => {
        if (funding) {
          this.currentFunding = funding;
        }
      }),
      this.tunnelDataStore.getCurrentPricing().subscribe(pricing => {
        if (pricing) {
          this.currentPricing = pricing;
        }
      })
    );
  }

  /** Calcule la pose via le backend et met à jour le store */
  /**
   * Récupère l'estimation des prestations de pose (SPID) pour le projet courant.
   *
   * `options.usePersistedHouseAge` doit être posé au chargement d'un tunnel existant : voir
   * {@link ComputeInstallationOptions}.
   */
  public async computeInstallation(options: ComputeInstallationOptions = {}): Promise<void> {
    const poseEnabled = await this.featureSettingsService.isPoseEnabled();

    if (!poseEnabled) {
      this.tunnelDataStore.disableCurrentInstallation();
      return;
    }

    try {
      this.tunnelDataStore.setInstallationLoading(true);
      const result = await this.getInstallationData({
        tunnelConfigurationId: this.configuration.tunnelId,
        houseMoreThan2YearsOld: options.usePersistedHouseAge ? undefined : this.currentInstallation?.more2Years,
      });
      this.tunnelDataStore.resetCurrentPricing();
      this.tunnelDataStore.resetCurrentFunding();
      this.tunnelDataStore.updateCurrentInstallation({
        more2Years: result.houseMoreThan2YearsOld,
        withInstallation: result.withInstallation,
        detailInstallation: result.installationPrice?.installationDetails
          ? JSON.parse(result.installationPrice.installationDetails)
          : null,
      });
      this.loadPricingFromInstallation(result);
    } catch (error) {
      logError(error);
    } finally {
      this.tunnelDataStore.setInstallationLoading(false);
    }
  }

  /** Charge le tarif conception/financement depuis le backend et met à jour le store */
  public async loadCarpentryPricing(): Promise<void> {
    try {
      await this.computeCarpentryPricing({
        tunnelConfigurationId: this.configuration.tunnelId,
        shouldRecalculate: false,
      });
    } catch (error) {
      logError(error);
    }
  }

  private async computeCarpentryPricing(input: GetPricingInput): Promise<void> {
    try {
      this.tunnelDataStore.setPricingLoading(true);
      const result: CarpentryTunnelPricingDto = await this.getCarpentryPricing(input);
      await this.updatePricingFromDto(result);
    } catch (error) {
      logError(error);
    } finally {
      this.tunnelDataStore.setPricingLoading(false);
    }
  }

  private async updatePricingFromDto(input: CarpentryTunnelPricingDto): Promise<void> {
    const featureSettings = await this.featureSettingsService.getSettings();

    if (featureSettings.pose) {
      this.updateInstallationState(input);
    } else {
      this.tunnelDataStore.disableCurrentInstallation();
    }

    if (featureSettings.pose && this.currentInstallation?.withInstallation && input.conceptionPrices?.withInstallation) {
      this.computePricingWithInstallation(input);
    } else if (input.conceptionPrices?.withoutInstallation) {
      this.computePricingWithoutInstallation(input);
    }

    if (featureSettings.financement) {
      this.loadFunding(input);
    } else {
      this.tunnelDataStore.disableCurrentFunding();
    }

    if (typeof input.discountEnum === 'number') {
      this.tunnelDataStore.updateCurrentDiscount(this.discountValueToDiscountEnum(input.discountEnum as number));
    } else {
      this.tunnelDataStore.updateCurrentDiscount(input.discountEnum);
    }
  }

  private computePricingWithInstallation(result: CarpentryTunnelPricingDto): void {
    this.baseComputePricing(result);
    this.tunnelDataStore.updateCurrentPricing({
      totalConception: this.toPrice(result.conceptionPrices?.withInstallation?.productsPrice),
    });
  }

  private computePricingWithoutInstallation(result: CarpentryTunnelPricingDto): void {
    this.baseComputePricing(result);
    this.tunnelDataStore.updateCurrentPricing({
      totalConception: this.toPrice(result.conceptionPrices?.withoutInstallation?.productsPrice),
    });
  }

  private baseComputePricing(result: CarpentryTunnelPricingDto): void {
    const installationDisabled = !this.featureSettingsService.poseEnabled;
    const totalWithoutFunding = installationDisabled
      ? result.conceptionPrices?.withoutInstallation?.totalPrice ??
        result.conceptionPrices?.withoutInstallation?.productsPrice ??
        result.totalWithoutFinancing
      : result.totalWithoutFinancing;

    this.tunnelDataStore.updateCurrentPricing({
      delivery: this.toPrice(result.deliveryPrice),
      totalInstallation: installationDisabled ? this.toPrice(0) : this.toPrice(result.installationPrices?.price),
      totalWithoutFunding: this.toPrice(totalWithoutFunding),
      delta: installationDisabled ? this.toPrice(0) : this.toPrice(result.conceptionPrices?.delta),
      totalWithFunding: result.totalWithFinancing,
    });
  }

  private loadPricingFromInstallation(input: CarpentryInstallationDto): void {
    const conceptionPriceDetail = input.withInstallation
      ? input.conceptionPrices?.withInstallation
      : input.conceptionPrices?.withoutInstallation;
    this.tunnelDataStore.updateCurrentPricing({
      totalConception: this.toPrice(conceptionPriceDetail?.totalPrice),
      delivery: this.toPrice(input.deliveryPrice),
      totalInstallation: this.toPrice(input.installationPrice?.price),
      totalWithoutFunding: this.toPrice(conceptionPriceDetail?.totalPrice),
      delta: this.toPrice(input.conceptionPrices?.delta),
    });
  }

  private updateInstallationState(result: CarpentryTunnelPricingDto): void {
    this.tunnelDataStore.updateCurrentInstallation({
      more2Years: result.houseMoreThan2YearsOld,
      withInstallation: result.withInstallation,
      detailInstallation: result.installationPrices?.installationDetails
        ? JSON.parse(result.installationPrices.installationDetails)
        : null,
    });
  }

  private loadFunding(result: CarpentryTunnelPricingDto): void {
    this.tunnelDataStore.updateCurrentFunding({
      ...this.mapCarpentryFundingState(result),
    });
  }

  private mapCarpentryFundingState(input: CarpentryTunnelPricingDto): FundingState {
    let fundingWithInstallation = this.buildEmptyFunding();
    let fundingWithoutInstallation = this.buildEmptyFunding();

    if (input.financing !== undefined) {
      fundingWithoutInstallation = {
        code: input.financing.select_bareme,
        duration: input.financing.select_duration,
        offerTable: this.mapRawOffersLiteOfferResults(JSON.parse(input.financing.offers)),
        ...this.getDataFromFundingOfferTable(
          input.financing.select_bareme,
          input.financing.select_duration,
          this.mapRawOffersLiteOfferResults(JSON.parse(input.financing.offers))
        ),
      };
    }

    if (input.financingWithInstallation !== undefined) {
      fundingWithInstallation = {
        code: input.financingWithInstallation.select_bareme,
        duration: input.financingWithInstallation.select_duration,
        offerTable: this.mapRawOffersLiteOfferResults(JSON.parse(input.financingWithInstallation.offers)),
        ...this.getDataFromFundingOfferTable(
          input.financingWithInstallation.select_bareme,
          input.financingWithInstallation.select_duration,
          this.mapRawOffersLiteOfferResults(JSON.parse(input.financingWithInstallation.offers))
        ),
      };
    }

    return {
      downPayment: input.downPayment,
      fundingWithInstallation,
      fundingWithoutInstallation,
    };
  }

  private async fidelityEnabled(): Promise<boolean> {
    return this.featureSettingsService.isFidelityEnabled();
  }

  private async computeFidelity(): Promise<void> {
    if (!(await this.fidelityEnabled())) return;
    if (!this.currentPricing?.totalWithoutFunding?.actualAmount) return;
    await this.computeFidelityPoint({
      amount: this.currentPricing.totalWithoutFunding.actualAmount,
      customerId: this.customerService.userDatas?.kfId,
    });
  }

  public async computeFidelityPoint(input: GetCustomerFidelityInfoNouveauPointInput): Promise<void> {
    if (!(await this.fidelityEnabled())) return;
    try {
      this.tunnelDataStore.setFidelityLoading(true);
      const [withInstallation, withoutInstallation] = await Promise.all([
        this.fidelityService.getCustomerFidelityCardInfoNouveauPoint(this.buildFidelityWithInstallationInput(input)),
        this.fidelityService.getCustomerFidelityCardInfoNouveauPoint(this.buildFidelityWithoutInstallationInput(input)),
      ]);
      this.tunnelDataStore.updateCurrentPricing({
        ...this.currentPricing,
        fidelity: [withInstallation, withoutInstallation],
      });
    } catch (e) {
      logError(e);
    } finally {
      this.tunnelDataStore.setFidelityLoading(false);
    }
  }

  private buildFidelityWithInstallationInput(
    input: GetCustomerFidelityInfoNouveauPointInput
  ): GetCustomerFidelityInfoNouveauPointInput {
    const otherTotal =
      this.currentFunding?.fundingWithInstallation?.total > 0
        ? this.currentFunding.fundingWithInstallation.total
        : (this.currentPricing?.totalWithFunding ?? 0) + (this.currentPricing?.delta?.actualAmount ?? 0);
    return {
      ...input,
      amount: this.currentInstallation?.withInstallation ? Math.floor(input.amount) : Math.floor(otherTotal),
    };
  }

  private buildFidelityWithoutInstallationInput(
    input: GetCustomerFidelityInfoNouveauPointInput
  ): GetCustomerFidelityInfoNouveauPointInput {
    const otherTotal =
      this.currentFunding?.fundingWithoutInstallation?.total > 0
        ? this.currentFunding.fundingWithoutInstallation.total
        : (this.currentPricing?.totalWithFunding ?? 0) - (this.currentPricing?.delta?.actualAmount ?? 0);
    return {
      ...input,
      amount: !this.currentInstallation?.withInstallation ? Math.floor(input.amount) : Math.floor(otherTotal),
    };
  }

  public async updateWithInstallation(withInstallation: boolean) {
    const poseEnabled = await this.featureSettingsService.isPoseEnabled();

    if (!poseEnabled) {
      this.tunnelDataStore.disableCurrentInstallation();
      return;
    }

    await this.updateInstallation({
      tunnelConfigurationId: this.configuration.tunnelId,
      installationUpdate: {
        withInstallation: withInstallation,
      },
    });
  }

  public async computeFunding(input: GetFundingDataInput) {
    const financementEnabled = await this.featureSettingsService.isFinancementEnabled();

    if (!financementEnabled) {
      // Financement coupé : on recharge quand même le pricing pour que les totaux suivent
      // le scénario de pose courant (le mapper de pricing repasse par disableCurrentFunding).
      this.tunnelDataStore.disableCurrentFunding();
      await this.loadCarpentryPricing();
      return;
    }

    try {
      this.tunnelDataStore.setFundingLoading(true);
      let result = await this.getFundingData(input);
      await this.updatePricing(result);
    } catch (error) {
      logError(error);
    } finally {
      this.tunnelDataStore.setFundingLoading(false);
    }
  }

  public async updateCarpentryConfiguration(data: CarpentryConfigurationData, withReset: boolean = true) {
    const nextConfiguration = {
      ...this.configuration,
      ...data,
    };
    this.configuration.tunnelId = nextConfiguration.tunnelId;
    this.configuration.title = nextConfiguration.title;
    this.tunnelDataStore.updateConfigurationData(CONFIG_CONTEXT.CARPENTRY, nextConfiguration);

    if (!this.configuration.tunnelId) {
      throw new Error("Impossible de mettre à jour le tunnel menuiserie : aucun tunnelId n'est disponible.");
    }

    const inputRequest = {
      tunnelConfigurationId: this.configuration.tunnelId,
      title: this.configuration.title,
      products: this.configuration.quotationRecords,
    };

    await this.updateCarpentryTunnel(inputRequest);

    if (withReset) {
      this.tunnelDataStore.resetCurrentInstallation();
      this.tunnelDataStore.resetCurrentPricing();
      this.tunnelDataStore.resetCurrentFunding();
    }
  }

  public async updateLockState(isLocked: boolean): Promise<void> {
    const params = new URLSearchParams();
    params.set('configurationId', this.configuration.id);
    params.set('isLocked', isLocked.toString());

    await this.put<void>(`${this.apiUrl}Configuration/LockState?${params.toString()}`, {});
    this.configuration.isLocked = isLocked;
    this.tunnelDataStore.updateConfigurationData(CONFIG_CONTEXT.CARPENTRY, this.configuration);
  }

  private async updatePricing(pricing?: CarpentryTunnelPricingDto) {
    if (pricing) {
      await this.updatePricingFromKitchenTunnelPricing(pricing);
    }
  }

  private async updatePricingFromKitchenTunnelPricing(input: CarpentryTunnelPricingDto) {
    const featureSettings = await this.featureSettingsService.getSettings();

    if (featureSettings.pose) {
      this.updateCarpentryInstallation(input);
    } else {
      this.tunnelDataStore.disableCurrentInstallation();
    }

    if (featureSettings.pose && this.currentInstallation?.withInstallation && input.conceptionPrices?.withInstallation) {
      this.computeCarpentryPricingWithInstallation(input);
    } else if (input.conceptionPrices?.withoutInstallation) {
      this.computeCarpentryPricingWithoutInstallation(input);
    }

    if (featureSettings.financement) {
      await this.loadCarpentryFunding(input);
    } else {
      this.tunnelDataStore.disableCurrentFunding();
    }
    if (typeof input.discountEnum === 'number') {
      this.tunnelDataStore.updateCurrentDiscount(this.discountValueToDiscountEnum(input.discountEnum as number));
    } else {
      this.tunnelDataStore.updateCurrentDiscount(input.discountEnum);
    }
  }

  private updateCarpentryInstallation(result: CarpentryTunnelPricingDto) {
    let detailInstallation = null;
    if (result.installationPrices?.installationDetails != undefined) {
      detailInstallation = JSON.parse(result.installationPrices?.installationDetails);
    }

    this.tunnelDataStore.updateCurrentInstallation({
      more2Years: result.houseMoreThan2YearsOld,
      withInstallation: result.withInstallation,
      detailInstallation: detailInstallation,
    });
  }

  private computeCarpentryPricingWithInstallation(result: CarpentryTunnelPricingDto) {
    this.baseComputeCarpentryPricing(result);
    this.tunnelDataStore.updateCurrentPricing({
      detailConception: new Map<string, Price>([
        ['productsPrice', this.toPrice(result.conceptionPrices?.withInstallation?.productsPrice)],
      ]),
      totalConception: this.toPrice(result.conceptionPrices?.withInstallation?.productsPrice),
    });
  }

  private computeCarpentryPricingWithoutInstallation(result: CarpentryTunnelPricingDto) {
    this.baseComputeCarpentryPricing(result);
    this.tunnelDataStore.updateCurrentPricing({
      detailConception: new Map<string, Price>([
        ['productsPrice', this.toPrice(result.conceptionPrices?.withoutInstallation?.productsPrice)],
      ]),
      totalConception: this.toPrice(result.conceptionPrices?.withoutInstallation?.productsPrice),
    });
  }

  private baseComputeCarpentryPricing(result: CarpentryTunnelPricingDto) {
    const installationDisabled = !this.featureSettingsService.poseEnabled;
    const totalWithoutFunding = installationDisabled
      ? result.conceptionPrices?.withoutInstallation?.totalPrice ??
        result.conceptionPrices?.withoutInstallation?.productsPrice ??
        result.totalWithoutFinancing
      : result.totalWithoutFinancing;

    this.tunnelDataStore.updateCurrentPricing({
      delivery: this.toPrice(result.deliveryPrice),
      totalInstallation: installationDisabled ? this.toPrice(0) : this.toPrice(result.installationPrices?.price),
      totalWithoutFunding: this.toPrice(totalWithoutFunding),
      delta: installationDisabled ? this.toPrice(0) : this.toPrice(result.conceptionPrices?.delta),
      totalWithFunding: result.totalWithFinancing,
    });
  }

  private async loadCarpentryFunding(result: CarpentryTunnelPricingDto) {
    this.tunnelDataStore.updateCurrentFunding({
      ...this.mapCarpentryTunnelPricingFundingState(result),
    });
  }

  private mapCarpentryTunnelPricingFundingState(input: CarpentryTunnelPricingDto): FundingState {
    let fundingWithInstallation = this.buildEmptyFunding();
    let fundingWithoutInstallation = this.buildEmptyFunding();

    if (input.financing !== undefined) {
      fundingWithoutInstallation = {
        code: input.financing.select_bareme,
        duration: input.financing.select_duration,
        offerTable: this.mapRawOffersLiteOfferResults(JSON.parse(input.financing.offers)),
        ...this.getDataFromFundingOfferTable(
          input.financing.select_bareme,
          input.financing.select_duration,
          this.mapRawOffersLiteOfferResults(JSON.parse(input.financing.offers))
        ),
      };
    }

    if (input.financingWithInstallation !== undefined) {
      fundingWithInstallation = {
        code: input.financingWithInstallation.select_bareme,
        duration: input.financingWithInstallation.select_duration,
        offerTable: this.mapRawOffersLiteOfferResults(JSON.parse(input.financingWithInstallation.offers)),
        ...this.getDataFromFundingOfferTable(
          input.financingWithInstallation.select_bareme,
          input.financingWithInstallation.select_duration,
          this.mapRawOffersLiteOfferResults(JSON.parse(input.financingWithInstallation.offers))
        ),
      };
    }
    return {
      downPayment: input.downPayment,
      fundingWithInstallation: fundingWithInstallation,
      fundingWithoutInstallation: fundingWithoutInstallation,
    };
  }

  public async selectOffer(code: string, duration: number, other: boolean = false) {
    const financementEnabled = await this.featureSettingsService.isFinancementEnabled();

    if (!financementEnabled) {
      this.tunnelDataStore.disableCurrentFunding();
      return;
    }

    await this.getFundingLegalInformation({
      tunnelConfigurationId: this.configuration.tunnelId,
      selectedBareme: code,
      financingDuration: duration,
    });
    await this.loadCarpentryPricing();
  }

  public async generateCarpentryPdf(input: HbmPdfViewModel) {
    return await this.getCarpentryPdf(input);
  }

  private getCarpentryTunnelByConfigId(configurationId: string): Promise<BaseCarpentryConfigurationDto> {
    return this.get<BaseCarpentryConfigurationDto>(`${this.apiUrl}Tunnel/${configurationId}`);
  }

  private getInstallationData(input: GetInstallationDataInput): Promise<CarpentryInstallationDto> {
    return this.post<CarpentryInstallationDto>(`${this.apiUrl}Tunnel/installation/${input.tunnelConfigurationId}`, {
      houseMoreThan2YearsOld: input.houseMoreThan2YearsOld,
    });
  }

  private getCarpentryPricing(input: GetPricingInput): Promise<CarpentryTunnelPricingDto> {
    return this.post<CarpentryTunnelPricingDto>(`${this.apiUrl}Tunnel/pricing/${input.tunnelConfigurationId}`, input);
  }

  //quand tu changes le withInstallation
  private updateInstallation(input: UpdateInstallationInput): Promise<void> {
    return this.putHbm<TunnelUpdateInstallation, void>(
      this.apiUrl + 'Tunnel/installation/' + input.tunnelConfigurationId,
      input.installationUpdate
    );
  }

  private getFundingData(input: GetFundingDataInput): Promise<CarpentryTunnelPricingDto> {
    return this.postHbm<GetFundingDataInput, CarpentryTunnelPricingDto>(
      this.apiUrl + 'Tunnel/financing/' + input.tunnelConfigurationId,
      undefined,
      input
    );
  }

  private getFundingLegalInformation(input: GetFundingLegalInformationInput): Promise<FundingLegalInformation> {
    return this.getHbm<FundingLegalInformation>(
      this.apiUrl + 'Tunnel/financing/legal-information/' + input.tunnelConfigurationId,
      input
    );
  }

  private updateCarpentryTunnel(input: CarpentryCreateUpdateTunnel): Promise<CarpentryConfiguration> {
    return this.putHbm<CarpentryCreateUpdateTunnel, CarpentryConfiguration>(
      this.apiUrl + 'Tunnel/update/' + input.tunnelConfigurationId,
      input
    );
  }

  private getCarpentryPdf(input: HbmPdfViewModel) {
    return this.postHbm<HbmPdfViewModel, any>(this.baseApiUrl + 'Pdf/GeneratePdf/carpentry/', input, {
      tunnelConfigurationId: input.tunnelConfigurationId,
    });
  }
}

export interface CarpentryOrderCheckSummary {
  isValid: boolean;
  result: CheckOrderResult;
  invalidProducts: ShoppingCartProduct[];
}
